import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import LiveClassesCalendar from './LiveClassesCalendar';
import LiveClassesHighlights from './LiveClassesHighlights';
import LiveClassSurvey from '../LiveClassSurvey';
import { useCheckIncludeProfiles } from '@/hooks/useAuthorityLevel';
import { DashboardContent } from '@/layouts/dashboard';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { TiaBanner } from '@/components/custom/tia-banner';
import tiaAula from '@/assets/images/tia/TIA-AULA.png';

const PLAYFUL_TAB_CLASSNAME = 'data-[state=active]:bg-[var(--color-mission)] data-[state=active]:text-white data-[state=active]:font-extrabold data-[state=active]:shadow-[0_3px_0_var(--color-mission-dark)] data-[state=active]:-translate-y-px';

function LiveClassesPlayful({ uri }) {
  const isStudent = useCheckIncludeProfiles({ only: ['student'] });
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') === 'calendario' ? 'calendario' : 'destaque';
  const handleTabChange = value => setSearchParams({ tab: value });

  const [weekDays, setWeekDays] = useState([]);

  const [notAnsweredSurveys, setNotAnsweredSurveys] = useState([]);
  const [currentSurvey, setCurrentSurvey] = useState(0);

  const breadCrumbs = {
    title: 'Cursos e Aulas',
    nav: [
      {
        route: uri,
        name: 'Aulas ao vivo',
        isActive: true
      }
    ]
  };

  return (
    <DashboardContent
      variant="plain"
      breadcrumbs={breadCrumbs}
    >
      <Tabs
        value={activeTab}
        onValueChange={handleTabChange}
      >
        <TiaBanner
          className="mb-6 mt-16"
          image={tiaAula}
          text="Sua programação de Aulas ao Vivo está aqui! Toque no card para entrar e boa aula! Se tiver dúvida, escreve no chat que a turma te ajuda. 🤜🤛"
        >
          <TabsList className="border border-neutral-lighter bg-white">
            <TabsTrigger
              value="destaque"
              className={PLAYFUL_TAB_CLASSNAME}
            >
              Destaques
            </TabsTrigger>
            <TabsTrigger
              value="calendario"
              className={PLAYFUL_TAB_CLASSNAME}
            >
              Calendário
            </TabsTrigger>
          </TabsList>
        </TiaBanner>

        <TabsContent value="destaque">
          <LiveClassesHighlights />
        </TabsContent>

        <TabsContent value="calendario">
          <LiveClassesCalendar
            weekDays={weekDays}
            setWeekDays={setWeekDays}
            setNotAnsweredSurveys={setNotAnsweredSurveys}
          />
        </TabsContent>
      </Tabs>

      {isStudent && notAnsweredSurveys.length > 0 && notAnsweredSurveys?.[currentSurvey] && (
        <LiveClassSurvey
          setCurrentSurvey={setCurrentSurvey}
          liveClassId={notAnsweredSurveys?.[currentSurvey]?.id}
          liveClassName={notAnsweredSurveys?.[currentSurvey]?.title}
        />
      )}
    </DashboardContent>
  );
}

export default LiveClassesPlayful;
